@switch (componentName()) { @case ("ConversationListComponent") {
<conversation-list></conversation-list>
} @case ("ConversationComponent") {
<conversation></conversation>
} @case ("CollaborationConversationListComponent") {
<particle-collaboration-conversation-list></particle-collaboration-conversation-list>
} @case ("FieldConversationComponent") {
<particle-field-conversation></particle-field-conversation>
} @default {
<conversation-list></conversation-list>
} }
